export const ClustersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clip-path="url(#a)">
      <path
        strokeWidth="1"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm0 3.334h16M4 14.666h16M9.333 4v16m5.334-16v16"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const FlatViewIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clip-path="url(#a)">
      <path
        strokeWidth="1"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const DownChevronIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="8"
    fill="none"
    viewBox="0 0 12 8"
  >
    <path
      fill="#C0C7DF"
      d="M6.357 6.747a1 1 0 0 1-1.468-.003L.264 1.718A1 1 0 0 1 .268.36L.305.32a1 1 0 0 1 1.469.003l3.855 4.19L9.505.342a1 1 0 0 1 1.469.003l.037.041a1 1 0 0 1-.003 1.358l-4.65 5.002Z"
    />
  </svg>
);
